<div class="selector">
    <div class="selector__inner">
        <shared-circle-btn class="selector__btn -for-deselected" [size]="size" [icon]="iconDeselected"
            [feel]="feelDeselected" (onClick)="handleSelected($event)" *ngIf="!isSelected"></shared-circle-btn>
        <shared-circle-btn class="selector__btn -for-selected" [size]="size" [icon]="iconSelected" [feel]="feelSelected"
            (onClick)="handleDeselected($event)" *ngIf="isSelected"></shared-circle-btn>
    </div>
</div>